import React from "react";
import BannerCard from "./BannerCard";
import Box from "@mui/material/Box";

type BannerProps = {
  bannerdetails: any[]; 
  page:any
  limit:any
  setPage: (page: number) => void
  totalPages:number
  bannerImagesLength:string
};

const Banner: React.FC<BannerProps> = ({ bannerdetails, page,limit,totalPages,setPage ,bannerImagesLength}) => {

  return (
    <div>
      <Box sx={{ background: "#f7f9fa", padding: "0 32px" }}>
        <BannerCard bannerdetails={bannerdetails} page={page} limit={limit} totalPages={totalPages} setPage={setPage} bannerImagesLength={bannerImagesLength}/>
      </Box>
    </div>
  );
}
export default Banner;